import React, { createContext, useContext, useState, useEffect } from 'react';

const QuoteCartContext = createContext(null);

export const QuoteCartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const saved = localStorage.getItem('nayaceros_cart');
      return saved ? JSON.parse(saved) : [];
    } catch { return []; }
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem('nayaceros_cart', JSON.stringify(items));
  }, [items]);

  // Each item: { product_id, nombre, ruta_img, codigo, variacion, cantidad }
  // Key: product_id + codigo (unique per variation)
  const addItem = (item) => {
    setItems(prev => {
      const key = item.codigo ? `${item.product_id}-${item.codigo}` : `${item.product_id}`;
      const existing = prev.find(i => {
        const iKey = i.codigo ? `${i.product_id}-${i.codigo}` : `${i.product_id}`;
        return iKey === key;
      });
      if (existing) {
        return prev.map(i => {
          const iKey = i.codigo ? `${i.product_id}-${i.codigo}` : `${i.product_id}`;
          return iKey === key ? { ...i, cantidad: i.cantidad + (item.cantidad || 1) } : i;
        });
      }
      return [...prev, { ...item, cantidad: item.cantidad || 1 }];
    });
  };

  const updateQuantity = (idx, cantidad) => {
    if (cantidad < 1) return;
    setItems(prev => prev.map((item, i) => i === idx ? { ...item, cantidad } : item));
  };

  const updateNotes = (idx, notas) => {
    setItems(prev => prev.map((item, i) => i === idx ? { ...item, notas } : item));
  };

  const removeItem = (idx) => {
    setItems(prev => prev.filter((_, i) => i !== idx));
  };

  const clearCart = () => {
    setItems([]);
    localStorage.removeItem('nayaceros_cart');
  };

  return (
    <QuoteCartContext.Provider value={{
      items, isOpen, setIsOpen,
      addItem, updateQuantity, updateNotes, removeItem, clearCart
    }}>
      {children}
    </QuoteCartContext.Provider>
  );
};

export const useQuoteCart = () => {
  const context = useContext(QuoteCartContext);
  if (!context) throw new Error('useQuoteCart must be used within QuoteCartProvider');
  return context;
};
